// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "modal__desktop_title-12EUT";
var _3 = "modal__desktop_paper-ecNqt";
var _4 = "modal__desktop_top_wrapper-7fT6S";
var _5 = "mobileDialog__dialog-2gP6O";
var _6 = "mobileDialog__header-GJah_";
var _7 = "mobileDialog__footer-zODvP";
var _8 = "mobileFooterButton-3BmY6";
export { _1 as "__esModule", _2 as "modal__desktop_title", _3 as "modal__desktop_paper", _4 as "modal__desktop_top_wrapper", _5 as "mobileDialog__dialog", _6 as "mobileDialog__header", _7 as "mobileDialog__footer", _8 as "mobileFooterButton" }
export default { "__esModule": _1, "modal__desktop_title": _2, "modal__desktop_paper": _3, "modal__desktop_top_wrapper": _4, "mobileDialog__dialog": _5, "mobileDialog__header": _6, "mobileDialog__footer": _7, "mobileFooterButton": _8 }
